import { render, staticRenderFns } from "./selfs.vue?vue&type=template&id=34242283&scoped=true"
import script from "./selfs.vue?vue&type=script&lang=js"
export * from "./selfs.vue?vue&type=script&lang=js"
import style0 from "./selfs.vue?vue&type=style&index=0&id=34242283&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34242283",
  null
  
)

export default component.exports